(() => {
  const desktopQuery = window.matchMedia('(min-width: 1025px)');
  const megaIds = [
    'item_39c67305-39d2-4a5b-b7de-626ecaa4ef09',
    'item_d5314b7b-6579-4e9b-ad06-993406bdaefe',
    'item_da8b0d59-f064-466b-9a73-f4ff9286b8dc'
  ];

  const megaItems = () => megaIds.map((id) => document.getElementById(id)).filter(Boolean);

  function closeMegas() {
    megaItems().forEach((item) => {
      item.classList.remove('kenza-mega-open');
      item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('kenza-mega-active');
  }

  function openMega(item) {
    const wasOpen = item.classList.contains('kenza-mega-open');
    closeMegas();
    if (wasOpen) return;
    ensureMegaFallback(item);
    item.classList.add('kenza-mega-open');
    item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('kenza-mega-active');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'kenza_navigation_open', navigation_label: item.querySelector(':scope > a')?.textContent.trim() || '' });
  }

  function ensureMegaFallback(item) {
    const templates = {
      'item_39c67305-39d2-4a5b-b7de-626ecaa4ef09': 'kenza-products-menu-template',
      'item_d5314b7b-6579-4e9b-ad06-993406bdaefe': 'kenza-space-menu-template',
      'item_da8b0d59-f064-466b-9a73-f4ff9286b8dc': 'kenza-brands-menu-template'
    };
    const target = item.querySelector('.t4s-lazy_menu');
    const template = document.getElementById(templates[item.id]);
    if (!target || !template || target.children.length) return;
    target.appendChild(template.content.cloneNode(true));
    target.classList.remove('isotopet4s-later');
    target.classList.add('kenza-space-menu-loaded');
  }

  function enhanceDesktopMega() {
    if (!desktopQuery.matches) {
      closeMegas();
      return;
    }

    megaItems().forEach((item) => {
      const trigger = item.querySelector(':scope > a');
      const panel = item.querySelector(':scope > .t4s-sub-menu');
      if (!trigger || !panel || trigger.dataset.kenzaReady === 'true') return;
      trigger.dataset.kenzaReady = 'true';
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('role', 'button');
      trigger.addEventListener('click', (event) => {
        if (!desktopQuery.matches) return;
        event.preventDefault();
        event.stopPropagation();
        openMega(item);
      });

      const container = panel.querySelector(':scope > .t4s-container') || panel;
      if (!container.querySelector('.kenza-mega-close')) {
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'kenza-mega-close';
        close.setAttribute('aria-label', 'Cerrar menú');
        close.innerHTML = '<span aria-hidden="true">×</span> Cerrar';
        close.addEventListener('click', closeMegas);
        container.prepend(close);
      }
    });
  }

  function enhanceMobileParents() {
    document.querySelectorAll('#menu-mb__ul .t4s-menu-item-has-children > a').forEach((anchor) => {
      if (anchor.dataset.kenzaParentReady === 'true') return;
      anchor.dataset.kenzaParentReady = 'true';
      const icon = anchor.querySelector('.t4s-mb-nav__icon');
      if (icon) {
        icon.setAttribute('role', 'button');
        icon.setAttribute('tabindex', '0');
        icon.setAttribute('aria-label', `Ver opciones de ${anchor.textContent.trim()}`);
        icon.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            icon.click();
          }
        });
      }
      anchor.addEventListener('click', (event) => {
        if (desktopQuery.matches || event.target.closest('.t4s-mb-nav__icon')) return;
        const href = anchor.getAttribute('href');
        if (!href || href === '#') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(href);
      }, true);
    });
  }

  function observeMobileMenu() {
    const drawer = document.getElementById('t4s-menu-drawer') || document.getElementById('menu-mb__ul')?.parentElement;
    if (!drawer || drawer.dataset.kenzaObserved === 'true') return;
    drawer.dataset.kenzaObserved = 'true';
    new MutationObserver(() => enhanceMobileParents()).observe(drawer, { childList: true, subtree: true });
    document.querySelectorAll('.t4s-toolbart-nav a, [data-menu-drawer]').forEach((trigger) => {
      if (trigger.dataset.kenzaMenuTriggerReady === 'true') return;
      trigger.dataset.kenzaMenuTriggerReady = 'true';
      trigger.addEventListener('click', () => window.setTimeout(enhanceMobileParents, 40));
    });
    enhanceMobileParents();
  }

  function setExplore(open) {
    const drawer = document.getElementById('kenza-explore-drawer');
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('kenza-explore-open', open);
    document.querySelectorAll('[data-kenza-explore-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', open ? 'true' : 'false'));
    if (open) window.setTimeout(() => drawer.querySelector('input[name="q"]')?.focus(), 120);
  }

  function enhanceExplore() {
    document.querySelectorAll('.t4s-toolbart-search a').forEach((trigger) => {
      if (trigger.dataset.kenzaExploreReady === 'true') return;
      trigger.dataset.kenzaExploreReady = 'true';
      trigger.dataset.kenzaExploreTrigger = '';
      trigger.setAttribute('aria-controls', 'kenza-explore-drawer');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', (event) => {
        if (desktopQuery.matches) return;
        event.preventDefault();
        setExplore(true);
      });
    });
    document.querySelectorAll('[data-kenza-explore-close]').forEach((button) => button.addEventListener('click', () => setExplore(false)));
  }

  function updateWhatsapp() {
    const link = document.querySelector('.kenza-whatsapp-float');
    if (!link) return;
    const message = `Hola, necesito ayuda con ${document.title}. ${window.location.href}`;
    link.href = `https://wa.me/56996884816?text=${encodeURIComponent(message)}`;
  }

  function observeNativeDrawers() {
    const drawers = [...document.querySelectorAll('#t4s-menu-drawer, #t4s-mini_cart')];
    const sync = () => document.body.classList.toggle('kenza-native-drawer-open', drawers.some((drawer) => drawer.getAttribute('aria-hidden') === 'false'));
    drawers.forEach((drawer) => new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] }));
    sync();
  }

  function init() {
    if (!document.querySelector('.kenza-mega-overlay')) {
      const overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.className = 'kenza-mega-overlay';
      overlay.setAttribute('aria-label', 'Cerrar menú');
      overlay.addEventListener('click', closeMegas);
      document.body.appendChild(overlay);
    }
    enhanceDesktopMega();
    enhanceMobileParents();
    observeMobileMenu();
    enhanceExplore();
    updateWhatsapp();
    observeNativeDrawers();
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMegas();
    setExplore(false);
  });
  document.addEventListener('shopify:section:load', init);
  desktopQuery.addEventListener?.('change', enhanceDesktopMega);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
